/** SLA layout tokens — rem-based (16px root). */
export const SLA_TABLE_SCROLL_Y = '22.5rem';
export const SLA_TABLE_SCROLL_X_LANDLORD = '61.25rem';
export const SLA_TABLE_SCROLL_X_OEM = '45rem';

/** Edit modals */
export const SLA_MODAL_BODY_MAX_HEIGHT = '26.25rem';
export const SLA_MODAL_WIDTH_LANDLORD_EDIT = '60rem';
export const SLA_MODAL_WIDTH_OEM_EDIT = '76rem';

/** Create wizard — dimensions vary per step  */
export const SLA_CREATE_STEP_WIDTH_PARTNER = '32rem';
export const SLA_CREATE_STEP_WIDTH_SCOPE = '36rem';
export const SLA_CREATE_STEP_WIDTH_LANDLORD_CONTRACT = '52rem';
export const SLA_CREATE_STEP_WIDTH_LANDLORD_REVIEW = '44rem';
export const SLA_CREATE_STEP_WIDTH_OEM_CONTRACT = '54rem';
export const SLA_CREATE_STEP_WIDTH_OEM_REVIEW = '48rem';

export const SLA_MODAL_VIEWPORT_MAX_WIDTH = '96vw';
/** Pinned-footer modals — leave room for title + action bar */
export const SLA_MODAL_SHELL_MAX_HEIGHT = 'calc(100dvh - 3rem)';
/** Review step — taller body, footer still in antd footer slot */
export const SLA_MODAL_SHELL_MAX_HEIGHT_REVIEW = 'calc(100dvh - 2rem)';

/** Table / KPI cards on SLA list pages — styled via `.sla-section-card` in globals.css */
export const SLA_SECTION_CARD_CLASS = 'sla-section-card';

export const SLA_FORM_FIELD_WIDTH = '8.75rem';
export const SLA_FORM_SELECT_WIDTH = '10rem';

/** OEM create modal — rate matrix table */
export const SLA_OEM_RATE_MATRIX_MAX_ROWS_CREATE = 20;
export const SLA_OEM_RATE_MATRIX_SCROLL_Y = '14rem';
